import React from "react";
import { Avatar, Box, Grid2, Stack, Typography } from "@mui/material";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

interface IImageGallery {
  items: string[];
  maxItem?: number;
}

const STANDAR_COL = 12;

function ImageGallery({ items = [], maxItem = 3 }: IImageGallery) {
  const displayedItems = items.slice(0, maxItem);
  const remainingItems = items.slice(maxItem);
  const remainingCount = remainingItems.length;

  const col = STANDAR_COL / maxItem;

  return (
    <PhotoProvider>
      <Box>
        <Grid2 container spacing={1}>
          {displayedItems.map((item, index) => {
            return (
              <Grid2 key={index} size={{ xs: col }}>
                <Box
                  sx={{
                    width: "100%",
                    paddingTop: "80%",
                    position: "relative",
                  }}
                >
                  {index === displayedItems.length - 1 &&
                    remainingCount > 0 && (
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          position: "absolute",
                          inset: 0,
                          zIndex: 10,
                          backgroundColor: "#00000066",
                          borderRadius: "10px",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "30px",
                            fontWeight: 600,
                            color: "common.white",
                          }}
                        >
                          +{remainingCount + 1}
                        </Typography>
                      </Stack>
                    )}
                  <PhotoView src={item}>
                    <Avatar
                      src={item}
                      alt="post image"
                      sx={{
                        position: "absolute",
                        zIndex: 1,
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px",
                      }}
                    />
                  </PhotoView>
                </Box>
              </Grid2>
            );
          })}
        </Grid2>
        {remainingItems.map((item) => {
          return <PhotoView src={item} />;
        })}
      </Box>
    </PhotoProvider>
  );
}

export default ImageGallery;
